if (!customElements.get('blog-projects')) {
  customElements.define('blog-projects', class BlogProjects extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.mainImg = this.querySelector('[data-project-image]');
      this.items = this.querySelectorAll('[data-project-item]');

      if (this.mainImg && this.items.length > 0) {
        this.initHover();
      }
    }

    initHover() {
      this.items.forEach(item => {
        item.addEventListener('mouseenter', () => {
          const newSrc = item.dataset.hoverImage;
          
          if (newSrc && this.mainImg.src !== newSrc) {
            this.mainImg.removeAttribute('srcset');
            this.mainImg.src = newSrc;
          }
        });
      });
    }
  });
}